import React, { useEffect, useState } from 'react';

const categories = ['All', 'Wildlife', 'Landscapes', 'Beaches', 'Culture'];

const GalleryPage = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');

  useEffect(() => {
    fetch('https://python.rock-safaris.com/gallery/') 
      .then(res => res.json())
      .then(data => setGalleryItems(data));
  }, []);

  const filteredItems = activeCategory === 'All'
    ? galleryItems
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-kenya-yellow py-5">
        <div className="container text-center py-4">
          <h1 className="display-5 fw-bold text-kenya-brown mb-3">Gallery</h1>
          <p className="lead text-kenya-brown mx-auto" style={{ maxWidth: 700 }}>
            Explore the breathtaking beauty of Kenya through our collection of stunning photographs
          </p>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="bg-kenya-white py-3 sticky-top" style={{ top: 70, zIndex: 100 }}>
        <div className="container text-center">
          <div className="btn-group">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`btn ${activeCategory === category ? 'btn-kenya-orange text-white' : 'btn-outline-kenya-orange'}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {filteredItems.map(item => (
              <div className="col-md-4" key={item.id}>
                <div className="card shadow border-0 h-100">
                  <div className="position-relative">
                    <img src={item.image} alt={item.title} className="card-img-top" style={{ height: 250, objectFit: 'cover' }} />
                    <div className="position-absolute bottom-0 start-0 w-100 p-3" style={{ background: 'rgba(0,0,0,0.4)' }}>
                      <h5 className="text-white mb-1">{item.title}</h5>
                      <small className="text-kenya-yellow">{item.category}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {filteredItems.length === 0 && (
              <div className="col-12 text-center text-muted py-5">No items in this category.</div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;